import { render, staticRenderFns } from "./matchWinloseDetail.vue?vue&type=template&id=552986a6&lang=pug&"
import script from "./matchWinloseDetail.vue?vue&type=script&lang=js&"
export * from "./matchWinloseDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports